import { UserTaskRole } from 'common/types';

export const BiddingRoleMap = {
  [UserTaskRole.ExternalContacts]: '制作方',
  [UserTaskRole.Allocator]: '需求方',
};

export const TaskRoleMap = {
  [UserTaskRole.Allocator]: '需求方',
  [UserTaskRole.ExternalContacts]: '制作方',
  [UserTaskRole.InternalContacts]: '审核方',
};

export enum InternalContactsBiddingStatus {
  unConfirmed = 'UNDETERMINED',
  confirmed = 'CONFIRMED',
  Revoked = 'REVOCATION',
  PreSelected = 'PRE_SELECTED', // 已预选
}

export const InternalContactsBiddingStatusMap = {
  [InternalContactsBiddingStatus.unConfirmed]: '待确认',
  [InternalContactsBiddingStatus.confirmed]: '已确认',
  [InternalContactsBiddingStatus.Revoked]: '已撤销',
  [InternalContactsBiddingStatus.PreSelected]: '已预选',
};

export enum ExternalContactsBiddingStatus {
  unConfirmed = 'UNDETERMINED',
  confirmed = 'CONFIRMED',
  Rejected = 'LOSE_ELECTION',
  Revoked = 'REVOCATION',
}

export const ExternalContactsBiddingStatusMap = {
  [ExternalContactsBiddingStatus.unConfirmed]: '待确认',
  [ExternalContactsBiddingStatus.confirmed]: '已确认',
  [ExternalContactsBiddingStatus.Rejected]: '已落选',
  [ExternalContactsBiddingStatus.Revoked]: '已取消',
};
